export default ":host {\n  height: 100%;\n  margin: 0;\n}"